import { render, staticRenderFns } from "./AddFcPackingAgent.vue?vue&type=template&id=952d64ee&"
import script from "./AddFcPackingAgent.vue?vue&type=script&lang=js&"
export * from "./AddFcPackingAgent.vue?vue&type=script&lang=js&"
import style0 from "./AddFcPackingAgent.vue?vue&type=style&index=0&id=952d64ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports